import {inject, Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {PortalLayoutSettings} from '../types/portalLayoutSettings';

export const PORTAL_LAYOUT_ATTRIBUTE = 'portalLayout';

// Reads the brand's layout block. The raw record is parsed once per loaded record, so templates can
// read the settings on every change detection without re-parsing.
@Injectable({providedIn: 'root'})
export class PortalLayoutService {
    private readonly authService = inject(AuthService);
    private parsedFrom: unknown = Symbol('unset');
    private parsed: PortalLayoutSettings = new PortalLayoutSettings();

    get settings(): PortalLayoutSettings {
        const raw: unknown = this.authService.companyData?.portalSettings?.layout;
        if (raw !== this.parsedFrom) {
            this.parsedFrom = raw;
            this.parsed = PortalLayoutSettings.fromJson(raw);
        }
        return this.parsed;
    }

    get isClassic(): boolean {
        return this.settings.variant === 'classic';
    }

    // Overlays and dialogs render outside the portal component tree, so the layout is marked on
    // <body> where every stylesheet can see it.
    applyToDocument(body: HTMLElement = document.body) {
        if (this.isClassic) {
            body.dataset[PORTAL_LAYOUT_ATTRIBUTE] = 'classic';
        } else {
            delete body.dataset[PORTAL_LAYOUT_ATTRIBUTE];
        }
    }
}
